export default "__VITE_ASSET__6j$Gvitf__"